import { ref } from 'vue';
import { forceUpdateDeliveryStatus, type ForceUpdateTargetStatus } from '../api/forceUpdateDeliveryStatus';

export const useForceUpdateDeliveryStatus = () => {
    const isLoading = ref(false);
    const error = ref<string | null>(null);

    const execute = async (applicationId: string, targetStatus: ForceUpdateTargetStatus): Promise<boolean> => {
        isLoading.value = true;
        error.value = null;

        try {
            await forceUpdateDeliveryStatus(applicationId, targetStatus);
            return true;
        } catch (error_) {
            error.value = error_ instanceof Error ? error_.message : '予期せぬエラーが発生しました';
            return false;
        } finally {
            isLoading.value = false;
        }
    };

    const clearError = () => {
        error.value = null;
    };

    return {
        isLoading,
        error,
        execute,
        clearError,
    };
};
